import React from 'react';
import { PropTypes } from 'prop-types';
export const ChartTitle = ({ party, onReset }) => (
  <hgroup className='heading'>
    <div className='title_and_bottom'>
      <h2 className='title'>
        Tendencias:
        {party && (
          <span
            className='partyName'
            style={{ color: party.color ? party.color : null }}
          >
            {' ' + party.name}*
          </span>
        )}
        {!party && <span className='partyName'> Todos los partidos</span>}
      </h2>
      {party && (
        <span className='btn' onClick={onReset}>
          VER TODOS
        </span>
      )}
    </div>
    <p className='subtitle'>
      {party && '*' + party.desc}
      {!party &&
        '*Escucha de la conversación en las cuentas de Twitter de los principales líderes políticos'}
    </p>
  </hgroup>
);


ChartTitle.propTypes = {
  party: PropTypes.shape({
     color: PropTypes.string,
     desc: PropTypes.string
   }),
   onReset: PropTypes.func.isRequired
};
ChartTitle.defaultPropTypes = {
  party: undefined
};
